import React, {Component} from "react"
import Banner from "../../components/BannerMp/BannerMp.jsx";
import Footer from "../../components/FooterMp/FooterMp";
import "./HomeMp.scss"
import About from "../../static/img/mp-about.jpg"
import WelcomeImg from "../../static/img/welcome-mp.jpg"
import business1 from "../../static/img/mp-business1.png"
import business2 from "../../static/img/mp-business2.png"
import business3 from "../../static/img/mp-business3.png"
import business4 from "../../static/img/mp-business4.png"
import Navs from "../../components/NavsMp/NavsMp";
import {NavLink} from "react-router-dom";
import Scrollbars from 'react-custom-scrollbars';

export default class HomeMp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newsIndex: 0,
            newsTabList: ["行业新闻", "公司新闻", "物流资讯"],
            cwCompanyNewsHomes: [],
            cwIndustryNewsHomes: [],
            cwLogisticsNewsHomes: [],
            partnerPics: [],
            qrcode:""
        }
    }

    componentDidMount() {
        this.$axios.apiList.getHomeMpData({})
            .then(res => {
                this.setState({
                    cwCompanyNewsHomes: res.data.cwCompanyNewsHomes,
                    cwIndustryNewsHomes: res.data.cwIndustryNewsHomes,
                    cwLogisticsNewsHomes: res.data.cwLogisticsNewsHomes,
                    partnerPics: res.data.partnerPics,
                    qrcode: res.data.qrcode,
                })
            })
            .catch(error => {
            })
    }

    render() {
        let {
            newsIndex,
            newsTabList,
            cwCompanyNewsHomes,
            cwIndustryNewsHomes,
            cwLogisticsNewsHomes,
            partnerPics,
            qrcode
        } = this.state;
        let newsList = [];
        switch (newsIndex) {
            case 0:
                newsList = cwIndustryNewsHomes;
                break;
            case 1:
                newsList = cwCompanyNewsHomes;
                break;
            case 2:
                newsList = cwLogisticsNewsHomes;
                break;
            default:
                newsList = cwCompanyNewsHomes;
                break;
        }
        ;
        // 滚动条参数
        let scroll = {
            // 如果最终结果表格内容与表格头部无法对齐。
            // 表格头需要增加空白列，弹性布局
            width: '100%',
            // 最大高度，内容超出该高度会出现滚动条
            height: document.body.clientHeight,//网页可见区域高
        };
        return (
            <div className="homeMp">
                <Navs/>
                <Scrollbars style={scroll}>
                    <div className="section">
                        <div className="section-wrapper">
                            <Banner/>
                        </div>
                    </div>
                    <div className="section">
                        <div className="section-business">
                            <div>
                                <div className="section-title">
                                    <div>Business<span> Scope</span>/业务范围</div>
                                </div>
                                <div className="business-content">
                                    <div className="item">
                                        <div className="icon">
                                            <img src={business1} alt=""/>
                                            <div className="title">
                                                业务分布
                                            </div>
                                            <div className="text">
                                                国内业务已遍及34个省市
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <img src={business3} alt=""/>
                                            <div className="title">
                                                车辆船舶
                                            </div>
                                            <div className="text">
                                                合作的车辆船舶约有3万辆(艘)
                                            </div>
                                        </div>

                                    </div>
                                    <div className="item">
                                        <div className="icon">
                                            <img src={business2} alt=""/>
                                            <div className="title">
                                                司机船主
                                            </div>
                                            <div className="text">
                                                合作的司机船主约有6万人
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <img src={business4} alt=""/>
                                            <div className="title">
                                                货运量
                                            </div>
                                            <div className="text">
                                                货运累计量已达8千万吨
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className="section-about">
                            <div>
                                <div className="section-title">
                                    <div>ABOUT <span>US</span>/关于我们</div>
                                </div>
                                <div className="about-content">
                                    <div className="left">
                                        <img src={About} alt=""/>
                                    </div>
                                    <div className="center">
                                        <div className="title">
                                        宜兴市交运物流信息科技有限公司
                                        </div>
                                        <div className="text">
                                            <p>
                                            宜兴市交运物流信息科技有限公司，是一家专业从事物流行业网络货运服务的现代化物流科技公司。
                                            </p>
                                            <p>
                                            公司成立于2018年，以先进的信息管理系统为平台、以现代物流技术为手段，构建综合运输网络和集货配送物流体系。目前本公司已建立起以宜兴市为中心，辐射全国的物流网络。一直以客户为中心，关注客户需求追求完美服务，具有绝对优势的输运经验。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="section-news">
                            <div>
                                <div className="section-title">
                                    <div>News <span>Center</span>/ 新闻中心</div>
                                </div>
                                <div className="section-Button">
                                    {
                                        newsTabList.map((item, index) => {
                                            return (
                                                <div
                                                    className={`item ${newsIndex === index ? "in" : null}`}
                                                    key={index}
                                                    onClick={e => {
                                                        this.setState({newsIndex: index})
                                                    }}>
                                                    {item}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="news-content">
                                    <div className="item">
                                        <NavLink to={newsList.length >= 1 ? `/newsDetails/${newsList[0].id}` : ""}
                                                 className="icon">
                                            <div className="title">
                                                {newsList.length >= 1 ? newsList[0].title : ""}
                                            </div>
                                            <div className="data">
                                                <div className="year-mon">
                                                    <div>
                                                        {newsList.length >= 1 ? newsList[0].year : ""}
                                                    </div>
                                                    <div>
                                                        {newsList.length >= 1 ? newsList[0].month : ""}
                                                    </div>
                                                </div>
                                                <div className="day">
                                                    {newsList.length >= 1 ? newsList[0].day : ""}
                                                </div>
                                            </div>
                                            <div className="text">
                                                {newsList.length >= 1 ? newsList[0].content : ""}
                                            </div>
                                        </NavLink>
                                        <NavLink to={newsList.length >= 2 ? `/newsDetails/${newsList[1].id}` : ""}
                                                 className="icon">
                                            <div className="title">
                                                {newsList.length >= 2 ? newsList[1].title : ""}
                                            </div>
                                            <div className="data">
                                                <div className="year-mon">
                                                    <div>
                                                        {newsList.length >= 2 ? newsList[1].year : ""}
                                                    </div>
                                                    <div>
                                                        {newsList.length >= 2 ? newsList[1].month : ""}
                                                    </div>
                                                </div>
                                                <div className="day">
                                                    {newsList.length >= 2 ? newsList[1].day : ""}
                                                </div>
                                            </div>
                                            <div className="text">
                                                {newsList.length >= 2 ? newsList[1].content : ""}
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className="item">
                                        <NavLink to={newsList.length >= 3 ? `/newsDetails/${newsList[2].id}` : ""}
                                                 className="icon">
                                            <div className="title">
                                                {newsList.length >= 3 ? newsList[2].title : ""}
                                            </div>
                                            <div className="data">
                                                <div className="year-mon">
                                                    <div>
                                                        {newsList.length >= 3 ? newsList[2].year : ""}
                                                    </div>
                                                    <div>
                                                        {newsList.length >= 3 ? newsList[2].month : ""}
                                                    </div>
                                                </div>
                                                <div className="day">
                                                    {newsList.length >= 3 ? newsList[2].day : ""}
                                                </div>
                                            </div>
                                            <div className="text">
                                                {newsList.length >= 3 ? newsList[2].content : ""}
                                            </div>
                                        </NavLink>
                                        <NavLink to={newsList.length >= 4 ? `/newsDetails/${newsList[3].id}` : ""}
                                                 className="icon">
                                            <div className="title">
                                                {newsList.length >= 4 ? newsList[3].title : ""}
                                            </div>
                                            <div className="data">
                                                <div className="year-mon">
                                                    <div>
                                                        {newsList.length >= 4 ? newsList[3].year : ""}
                                                    </div>
                                                    <div>
                                                        {newsList.length >= 4 ? newsList[3].month : ""}
                                                    </div>
                                                </div>
                                                <div className="day">
                                                    {newsList.length >= 4 ? newsList[3].day : ""}
                                                </div>
                                            </div>
                                            <div className="text">
                                                {newsList.length >= 4 ? newsList[3].content : ""}
                                            </div>
                                        </NavLink>
                                    </div>

                                </div>
                                <NavLink to="/news">
                                    <div className="more-news">
                                        更多新闻 &gt;
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                        <div className="section-sketch">
                            <div>
                                <div className="section-title">
                                    <div>Platform <span>sketch</span>/平台简述</div>
                                </div>
                                <div className="sketch-content">
                                    <div className="left">
                                        <div className="title">
                                            网络货运平台
                                        </div>
                                        <div className="content">
                                        宜兴交运运用互联网与大数据技术，为传统物流业装上智慧大脑。为司机、货主提供一站式在线交易服务的优质网络货运平台。可根据车辆位置、车型、车况精准调度，为运输计划提供车货匹配服务。对运输车辆进行实时跟踪，提供完善的方案，确保运力充足可靠。并提供在线结算、支付和开具运输发票，支持银联、微信、支付宝等多种支付方式。
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="pic">
                                            <img src={qrcode} alt=""/>
                                        </div>
                                        <div className="saoma">
                                            扫码下载
                                        </div>
                                        {/* <NavLink to="/guide">
                                            <div className="jump">
                                                操作指引&gt;&gt;
                                            </div>
                                        </NavLink> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="section-center">
                        </div>
                        <div className="section-customers">
                            <div className="background">
                                <div className="section-title">
                                    <div>Partner <span>customers</span>/ 合作伙伴</div>
                                </div>
                                <div className="customers-content">
                                    <div className="item">
                                        <div className="icon">
                                            <img src={partnerPics[0]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[1]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[2]} alt=""/>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="icon">
                                            <img src={partnerPics[3]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[4]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[5]} alt=""/>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="icon">
                                            <img src={partnerPics[6]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[7]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[8]} alt=""/>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="icon">
                                            <img src={partnerPics[9]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[10]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[11]} alt=""/>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="icon">
                                            <img src={partnerPics[12]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[13]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[14]} alt=""/>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="icon">
                                            <img src={partnerPics[15]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[16]} alt=""/>
                                        </div>
                                        <div className="icon">
                                            <img src={partnerPics[17]} alt=""/>
                                        </div>
                                    </div>
                                    <div className="Tips">
                                        排名不分先后，版面有限，仅展示部分品品牌
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section">
                        <div className="section-wrapper section-footer">
                            <div>
                                <div className="welcome">
                                    <img src={WelcomeImg} alt=""/>
                                </div>
                                <Footer/>
                            </div>
                        </div>
                    </div>
                </Scrollbars>
            </div>
        )
    }
}
